"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = _interopRequireDefault(require("../Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Chips(props) {
  let {
    size = "normal",
    type,
    title,
    action
  } = props;
  let background;
  let textColor;
  let paddingY;
  let fontSize;
  let fontFamily;
  let borderRadius;

  if (size === "small") {
    borderRadius = "l";
    paddingY = "m";
    fontSize = "s";
    fontFamily = "main";
  } else if (size === "compacted") {
    borderRadius = "l";
    paddingY = "m";
    fontSize = "s";
    fontFamily = "main";
  } else if (size === "normal") {
    paddingY = "xm";
    fontSize = "m";
    fontFamily = "mainBold";
    borderRadius = "xl";
  }

  if (type === "normal") {
    background = "common.white";
    textColor = "common.black";
  } else if (type === "primary") {
    background = "primary.main";
    textColor = "common.white";
  } else if (type === "light") {
    textColor = "primary.main";
    background = "primary.light940";
  } else if (type === "primaryTransparent") {
    textColor = "common.white";
    background = "primary.light980";
  } else if (type === "white") {
    textColor = "primary.main";
    background = "common.white";
  } else if (type === "success") {
    textColor = "common.white";
    background = "green.main";
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    br: borderRadius,
    style: {
      minWidth: props.size === "small" ? undefined : 100
    },
    px: "xm",
    py: paddingY,
    bg: background
  }, /*#__PURE__*/_react.default.createElement(_.Stack, {
    distribution: action ? "space-between" : "center"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    alignment: "center",
    color: props.textColor ? props.textColor : textColor,
    ff: fontFamily,
    fs: fontSize
  }, title ?? "-"), action ? action : null));
}

var _default = Chips;
exports.default = _default;